import { onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'

export function useScrollHeader() {
    const store = useStore()
    let lastScrollTop = 0
    let scrollLock = false

    // 向下滚动，隐藏头部
    function onScrollDownAction() {
        store.commit("open/header", false);
    }

    // 回到顶部，显示头部
    function onScrollToTopAction() {
        store.commit("open/header", true);
    }

    function handleScroll() {
        const scrollTop = window.scrollY
        // 回到页面最顶部
        if (scrollTop <= 0) {
            onScrollToTopAction()
            lastScrollTop = 0
            return
        }
        // 向下滚动
        if (scrollTop > lastScrollTop) {
            if (!scrollLock) {
                scrollLock = true
                onScrollDownAction()
                setTimeout(() => {
                    scrollLock = false
                }, 300)
            }
        }
        lastScrollTop = scrollTop
    }

    onMounted(() => {
        window.addEventListener('scroll', handleScroll)
    })

    onUnmounted(() => {
        window.removeEventListener('scroll', handleScroll)
    })
}